import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	gap: 1.25rem;
`;

export const Header = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	padding-top: 1rem;
	padding-left: 1rem;
	padding-right: 1rem;
`;

export const Options = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	flex: 1 1 auto;
	overflow-y: auto;
	padding-left: 1rem;
	padding-right: 1rem;
`;

export const Chevron = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${({ theme }) => theme.v2.color.neutral[500]};
	flex-shrink: 0;
	transition: color 120ms ease;
`;

export const MethodCard = styled.button`
	display: flex;
	align-items: center;
	gap: 0.75rem;
	width: 100%;
	padding: 0.5rem 1rem;
	border-radius: 10px;
	border: 1.5px solid ${({ theme }) => theme.v2.color.neutral[200]};
	background: ${({ theme }) => theme.v2.color.white[500]};
	cursor: pointer;
	text-align: left;
	transition:
		border-color 120ms ease,
		background-color 120ms ease;

	&:hover {
		border-color: ${({ theme }) => theme.v2.color.secondary[1000]};
		background: ${({ theme }) => theme.v2.color.secondary[200]};
	}

	&:hover ${Chevron} {
		color: ${({ theme }) => theme.v2.color.secondary[1000]};
	}

	&:focus-visible {
		outline: 2px solid ${({ theme }) => theme.v2.color.secondary[1000]};
		outline-offset: 2px;
	}
`;

export const MethodIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 36px;
	height: 36px;
	border-radius: 8px;
	background: ${({ theme }) => theme.v2.color.neutral[100]};
	color: ${({ theme }) => theme.v2.color.neutral[700]};
	flex-shrink: 0;
`;

export const MethodText = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1 1 auto;
	min-width: 0;
`;
